import type { RmaFilters } from '../types';

export const rmaKeys = {
  all: ['rma'] as const,
  lists: () => [...rmaKeys.all, 'list'] as const,
  list: (filters: RmaFilters) => [...rmaKeys.lists(), filters] as const,
  details: () => [...rmaKeys.all, 'detail'] as const,
  detail: (id: string) => [...rmaKeys.details(), id] as const,
  activity: (id: string) => [...rmaKeys.all, 'activity', id] as const,
  quoteContext: (quoteId: string) => [...rmaKeys.all, 'quote-context', quoteId] as const,
};
